import { apiCall } from '@/lib/api-client';

/**
 * F5-R6c · Admin 14 «Chat y notificaciones» — cliente del grupo.
 * Server: api/src/admin/system-config/chat-notify.controller.ts (solo admin).
 */

export interface ChatNotifyItem {
  key: string;
  value: unknown;
  updatedAt: string;
  updatedBy: string | null;
}

export interface ChatNotifyHistoryRow {
  key: string;
  oldValue: unknown;
  newValue: unknown;
  actorName: string | null;
  at: string;
}

export const chatNotifyApi = {
  list: () => apiCall<{ items: ChatNotifyItem[] }>('/admin/chat-notify-config'),

  save: (changes: Array<{ key: string; value: unknown }>) =>
    apiCall<{ saved: string[] }>('/admin/chat-notify-config/save', {
      method: 'POST',
      body: { changes },
    }),

  history: () => apiCall<{ items: ChatNotifyHistoryRow[] }>('/admin/chat-notify-config/history'),
};
